module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00003-fs8.010a8e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00003-fs8.png
// module id = 157
// module chunks = 0